/**
 * @Author:
 * @Description:
 * @DateTime: Created in 17:28 2020/10/16
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop, Watch } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import _ from 'lodash';
import { createBEM } from 'src/util/bem';
import './qualityRank.less';
import IndexPageApi, { IndexPageDOI } from '../api/IndexPage';
import EnumStationType from 'src/enums/enumStationType';
import TextMarquee from 'src/components/textMarquee/textMarquee';

@Component
export default class QualityRank extends Vue.Component<{ type: number; time: number; rankType: string }> {
    @Prop({
        type: Number,
    })
    type!: number;

    @Prop({
        type: Number,
        default: 5000,
    })
    time!: number;

    @Prop({
        type: String,
        default: '',
    })
    rankType!: string;

    current = '';

    totalCount = 0;
    currentPage = 1;
    rows: IndexPageDOI.OverproofStationI[] = [];
    itv;
    tabs: IndexPageDOI.RankingRowI[] = [];

    get getCurrentRows(): { device_name: string; value: number }[] {
        if (!this.current) {
            return [];
        } else {
            return this.tabs.find(i => i.key === this.current)!.data;
        }
    }

    @Watch('type')
    typeChange() {
        this.currentPage = 1;
        clearInterval(this.itv);
        this.search();
    }

    async search() {
        let field;
        if (this.type === EnumStationType.Water.getId()) {
            if (this.rankType === 'top') {
                field = 'surfacewater_sort_front';
            } else {
                field = 'surfacewater_sort_queen';
            }
        } else {
            if (this.rankType === 'last') {
                field = 'source_pollution_sort_front';
            } else {
                field = 'source_pollution_sort_queen';
            }
        }
        let { code, data } = await IndexPageApi.searchMonitoringRanking({ [field]: 5 });
        if (code === 0) {
            this.tabs = data[field];
            this.current = this.tabs[0].key;
            this.startInterver();
        }
    }
    startInterver() {
        this.itv = setInterval(() => {
            let index = this.tabs.findIndex(i => i.key === this.current);
            if (index === this.tabs.length - 1) {
                index = 0;
            } else {
                index++;
            }
            this.current = this.tabs[index].key;
        }, this.time);
    }
    mounted() {
        this.search();
    }
    beforeDestroy() {
        clearInterval(this.itv);
    }

    render(h) {
        let bem = createBEM('quality-rank-' + this.rankType);

        return (
            <div class={bem()}>
                <div class={bem('title')}>监测质量排名（{this.rankType === 'top' ? '前五' : '后五'}）</div>
                <div class={bem('tab')}>
                    <tabs value="name1" v-model={this.current}>
                        {this.tabs.map(i => <tab-pane label={i.name} name={i.key} />)}
                    </tabs>
                </div>
                <div class={bem('content')}>
                    <div class={bem('head')}>
                        <div>序号</div>
                        <div>站点名称</div>
                        <div>浓度</div>
                    </div>
                    {this.getCurrentRows.map((i, index) => {
                        return (
                            <div class={bem('row')} key={this.current + '$' + index}>
                                <div>NO.{index + 1}</div>
                                <TextMarquee>{i.device_name}</TextMarquee>
                                <div>{i.value}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}
